import axios from "./axios";

class ProfileService {
  fetch = async () => {
    try {
      const response = await axios.post("/profile/fetch", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getUPIQR = async (amount, use_case) => {
    try {
      const response = await axios.post("/pg/get_upi_qr", { amount, use_case });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  txnStatus = async (order_id) => {
    try {
      const response = await axios.post("/pg/txn_status", { order_id });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new ProfileService();
